import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useUserRole } from "@/hooks/useUserRole";

/**
 * Redirect already-authenticated users away from public registration pages
 * to the dashboard most appropriate for their existing role.
 *
 * Used by /join/provider, /join/sales, /join/pharmacy so logged-in users
 * don't see a fresh signup form.
 */
export const useRedirectIfAuthed = () => {
  const { user, loading: authLoading } = useAuth();
  const { isAdmin, isProvider, isSalesperson, isPharmacy, loading: roleLoading } = useUserRole();
  const navigate = useNavigate();

  useEffect(() => {
    if (authLoading || roleLoading) return;
    if (!user) return;

    if (isAdmin) navigate("/admin", { replace: true });
    else if (isProvider) navigate("/provider", { replace: true });
    else if (isSalesperson) navigate("/sales", { replace: true });
    else if (isPharmacy) navigate("/pharmacy", { replace: true });
    else navigate("/dashboard", { replace: true });
  }, [user, authLoading, roleLoading, isAdmin, isProvider, isSalesperson, isPharmacy, navigate]);

  return { checking: authLoading || roleLoading };
};
